module.exports = __webpack_public_path__ + "static/fonts/realiance-icons.76c8589a.woff2";